module.exports = __webpack_public_path__ + "static/media/dark-diff.818d9b49.svg";